import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={'https://grabme.s3.ap-south-1.amazonaws.com/golisoda.jpeg'} className="App-logo" alt="logo" />
      </header>
    </div>
  );
}

export default App;
